<ng-container *transloco="let t; read: 'user'">
  <div class="p-5">
    <div class="flex items-center">
      <div>
        <span class="flex items-center">
          <drdp-title [title]="t('addNewChild.search.title')"></drdp-title>
          <i class="uil uil-info-circle text-xl ml-2 mb-2 cursor-pointer "
            [matTooltip]="t('addNewChild.search.tooltip')"
          matTooltipPosition="right" matTooltipClass="custom-tooltip"></i>
        </span>
      </div>
    </div>

    <drdp-container>
      <drdp-container color="lightBlue">
        <form class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 p-2 gap-3 flex-row content-center"
          [formGroup]="searchForm">
          <div class="col-span-1">
            <label class="required">
              {{ t('addNewChild.common.firstName') }}
            </label>
            <div class="basis-1/2 border-b border-black">
              <input matInput [placeholder]="t('addNewChild.common.firstName')" autocomplete="off" type="text"
                formControlName="firstName" maxlength="50">
            </div>
          </div>
          <div class="col-span-1">
            <label class="required">
              {{ t('addNewChild.common.lastName') }}
            </label>
            <div class="basis-1/2 border-b border-black">
              <input matInput [placeholder]="t('addNewChild.common.lastName')" autocomplete="off" type="text"
                formControlName="lastName" maxlength="50">
            </div>
          </div>
          <div class="col-span-1">
            <drdp-date-picker [label]="t('addNewChild.common.dob')" [initialDate]="dob?.value" labelClasses="pb-3" [isRequired]="true"
              (emitDate)="handleDate($event)">
            </drdp-date-picker>
          </div>
          <div class="col-span-1">
            <div><span class="font-bold">{{ t('addNewChild.search.additionalFilters') }}</span></div>
            <mat-radio-group [attr.aria-label]="t('addNewChild.common.selectAnOption')" class="flex gap-3" formControlName="additionalFilter">
              <mat-radio-button [value]="subFilter.None" color="primary">{{ t('addNewChild.search.filterNone') }}</mat-radio-button>
              <mat-radio-button [value]="subFilter.Subgroups" color="primary">{{ t('addNewChild.search.filterSubgroups') }}</mat-radio-button>
            </mat-radio-group>
          </div>
          @if (additionalFilter.value == subFilter.Subgroups) {
            <div
              class="col-span-1 md:col-span-3 lg:col-span-4 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-3">
              <div class="col-span-1">
                <label class="m-0 text-sm flex items-center" style="min-height: 2.5rem;">
                  <!-- Server-supplied state configuration label: not translated. -->
                  {{ ssidLabel }}
                </label>
                <div class="basis-1/2 border-b border-black">
                  <input matInput [placeholder]="ssidPlaceholder" autocomplete="off" type="text"
                    formControlName="ssid" maxlength="50">
                </div>
              </div>
              <div class="col-span-1">
                <label>
                  {{ t('addNewChild.common.drdpId') }}
                </label>
                <div class="basis-1/2 border-b border-black">
                  <input matInput (keypress)="numberOnly($event)" [placeholder]="t('addNewChild.common.drdpId')" autocomplete="off"
                    type="text" formControlName="drdpId" maxlength="50">
                </div>
              </div>
              <div class="col-span-1">
                <drdp-select-county #countySelect [initialCountyIds]="null" (county)="handleChosenCounty($event)"
                  [stateId]="userStateId" [multiSelect]="false">
                </drdp-select-county>
              </div>
            </div>
          }
          <div class="col-span-1 md:col-start-5 self-end justify-center md:justify-self-end">
            <drdp-btn type="submit" (click)="search()" class="mr-2">{{ t('addNewChild.common.search') }}</drdp-btn>
            <drdp-btn type="button" (click)="clear()" color="outline">{{ t('addNewChild.common.clear') }}</drdp-btn>
          </div>
        </form>
      </drdp-container>
      <div class="p-5 w-full">
        <drdp-add-edit-table viewIcon="uil uil-file-alt text-drdpblue-300" (iconActionItem)="actionItem($event)" (actionIconClicked)="openEnrollmentModal($event)"
          [dataSource]="dataSource" [tableData]="tableData" [columns]="tableColumns">
        </drdp-add-edit-table>
      </div>
    </drdp-container>
  </div>
  <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="totalData" [pageIndex]="pageIndex"
    (page)="paginateTable(false)">
  </mat-paginator>
  @if (showCheckbox) {
    <div class="flex flex-wrap mx-2 my-2 justify-center items-center gap-3">
      <mat-checkbox color="primary" (click)="handleCheckbox()">{{ t('addNewChild.search.acknowledgeNotListed') }}</mat-checkbox>
      <drdp-btn [disabled]="disableAddChildBtn" type="button" color="filled" (click)="handleAddChildBtn()">{{ t('addNewChild.common.addNewChild') }}</drdp-btn>
    </div>
  }
</ng-container>
